import React from 'react';
import store from '../..';
import MembershipVacancyTemplate from '../../components_membership_hotel/template/hotel/membershipVacancyTemplate';
import { apiKeyCheck, vacancyPublic } from '../../const';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
import commonUtil from "../../common/commonUtil";
import common from '../../resources/js/common/common';
class MembershipVacancy extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // 検索条件保存モーダル
            membershipPopup: false,
            // カレンダーモーダル
            calendarPopup: false,
            // チェックリストモーダル
            checkListPopup: false,
            // 施設カレンダーモーダル
            facilityCalendarPopup: false,
            // 施設ID
            facilityId: "",
            // ポップアップ用施設空室状況情報
            vacancyInfo: [],
            memberVacancyInfo: [],
            ippanVacancyInfo: [],
            facilityTel: "",
            // 予約確認モーダル
            membershipReservationConfPopup: false,
            // 施設予定確認モーダル
            membershipReservationCancelPopup: false,
            reservationConfList: [],
        };
    };

    render() {
        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            },
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };

        // 施設カレンダーモーダル
        const onClickCloseFacilityCalendarWindow = () => { this.setState({ facilityCalendarPopup: false }); }

        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => { this.setState({ membershipReservationCancelPopup: false }); };

        // 施設カレンダーモーダル
        const onClickOpenFacilityCalendarWindow = (req, name) => {
          const start = new Date(req.startDate);
          const end = new Date(req.endDate);
          const riyoDateFrom = commonUtil.getStringFromDate(start, "yyyy-MM-dd");
          const riyoDateTo = commonUtil.getStringFromDate(end, "yyyy-MM-dd");
          const shisetsuCdList = req.shisetsuCd ? [req.shisetsuCd] : null;
        //   const grade = store.getState().gradeData.filter(data => {
        //     return data.selected
        //   })[0].grade;
        //   const roomGradeList = grade ? [grade] : null;
          const roomGradeList = getGradeListParam(store.getState().gradeData);
          this.setState(
              {
                  facilityCalendarPopup: true,
                  facilityId: req.shisetsuCd ? req.shisetsuCd : null,
                  facilityCalendarFlg: true,
                  popupTitle: name ? name : "",
                  startDate: start
              }
          );
          const param = {
            shisetsuCdList,
            roomGradeList,
            riyoDateFrom,
            riyoDateTo
          }
          // カレンダー検索用検索情報取得
            common.doPost(vacancyPublic, param, afterVacancyPublic);
            // ★ローカル確認用 ↓↓↓
            // sleep(2000).then(() => {
            //     afterVacancyPublic({ data: vacancyPublicLocalData })
            // })
            // ★ローカル確認用 ↑↑↑

        }
        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({membershipReservationCancelPopup: true});
        }

        // カレンダーモーダル
        const onClickOpenCalendarWindow = (e) => {
            this.setState({ calendarPopup: !this.state.calendarPopup });
            let checkInFlg = false;
            let checkOutFlg = false;
            let vacancyCheckFlg = true;
            let title = "日付を選択";
            // if (e != undefined) {
                // if (e.target.id === 'dateSelection') {
                //     checkInFlg = false;
                //     checkOutFlg = false;
                //     vacancyCheckFlg = true;
                //     title = "日付を選択"
                // }
            this.setState(
                {
                    checkInFlg: checkInFlg,
                    checkOutFlg: checkOutFlg,
                    vacancyCheckFlg: vacancyCheckFlg,
                    popupTitle: title
                }
            );
            // }
        }

        // 予約情報取得後処理
        const afterVacancyPublic = (res) => {
            if (res.data.resultCode !== '0') {

            } else {
              this.setState(
                  {
                    vacancyItems: res.data.kushitsuList[0].kushitsuDateList,
                    facilityTel: res.data.kushitsuList[0].shisetsuTel
                  }
              );
            }
        }

        // カレンダー検索用検索情報取得
        const onClickCalendarMove = (param) => {
          // カレンダー検索用検索情報取得
          common.doPost(vacancyPublic, param, afterVacancyPublic);
        }
        const setVacancyInfo = (list) => { this.setState({ vacancyInfo: list }); };
        return (
            <div style={style.base}>
                <MembershipVacancyTemplate
                    state={this.state}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCalendarMove={onClickCalendarMove}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    onClickOpenFacilityCalendarWindow={onClickOpenFacilityCalendarWindow}
                    onClickCloseFacilityCalendarWindow={onClickCloseFacilityCalendarWindow}
                    setVacancyInfo={setVacancyInfo}
                    toHotelSearchView={toHotelSearchView}
                />
            </div>
        )
    }
}

// ホテル検索へ施設、日付を引き継いで遷移
const toHotelSearchView = (store, history, shisetsuCd, date) => {
    const state = store.getState().login
    let apiKey = null
    if (Object.keys(state).length !== 0) {
        apiKey = state.apiKey
    }
    if (apiKey) {
        common.doPost(apiKeyCheck, { apikey: apiKey }, (res) => {
            const hasSession = res.data ? true : false;
            naviToHotelSearchView(hasSession, store, history, shisetsuCd, date);
        });
    } else {
        naviToHotelSearchView(false, store, history, shisetsuCd, date);

    }
}

const naviToHotelSearchView = (hasSession, store, history, shisetsuCd, date) => {
    if (!hasSession) {
        store.dispatch({ type: "CLEAR_STATE" })
        history.push("/reserve/login", { prevRef: 'vacancy', shisetsuCd, date })
    } else {
        let state = store.getState().login;
        if (state.loginType === 'CRAWL') {
            store.dispatch({ type: "CLEAR_STATE" })
            history.push("/reserve/login", { prevRef: 'vacancy', shisetsuCd, date })
        } else {
            history.push('/reserve/hotel/search', { prevRef: 'vacancy', shisetsuCd, date })
        }
    }
}


export default MembershipVacancy;

// Storeに保持しているgradeDataからpublicVacancyの部屋グレードリストを作成
export const getGradeListParam = (gradeData) => {
    const selectedGrades = gradeData.filter(data => {
        return data.checked;
    });
    if (selectedGrades.length === 0) {
        return null;
    }
    const ret = selectedGrades.map(item => {
        return item.grade;
    });

    return ret;

}


// 改行を表す文字を改行に変える 施設名表示用
export const replaceLineBreakCharToLineBreak = (value) => {
    if (!value) {
        return value;
    }
    return value.replaceAll('\\r\\n', '\n');

}